<script>
	export let name;
</script>

<main>
	<h1>42</h1>
	<p>{name}'s Answer to the Ultimate Question of Life, the Universe, and Everything</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>